import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Button, Dropdown, Menu, Radio, Checkbox } from "antd";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT_USER, LOGOUT } from "reducers/authReducer";
import { DownOutlined } from "@ant-design/icons";
import {
  EditBioModal,
  EditPrivacyModal,
  EditPaymentModal,
  EditPermissionsModal,
  EditNotificationModal,
} from "components/Modals";
import Clock from "common/Clock";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import VerifyPinModal from "components/Modals/VerifyPinModal";
import { REQUEST_VERIFICATION_CODE } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";

const HeaderPanel: FC<{ socket: ISocket; dashboard?: boolean }> = ({
  socket,
  dashboard,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [selectedOrg, setOrg] = useState<string>("");
  const [image, setImage] = useState();
  const [editPrivacyModalOpen, setEditPrivacyModalOpen] =
    useState<boolean>(false);
  const [editPaymentModalOpen, setEditPaymentModalOpen] =
    useState<boolean>(false);
  const [confirmationDialog, setConfirmationDialog] = useState<boolean>(false);
  const [editPermissionsModalOpen, setEditPermissionsModalOpen] =
    useState<boolean>(false);
  const [editNotificationModalOpen, setEditNotificationModalOpen] =
    useState<boolean>(false);
  const [verifyPinModalOpen, setVerifyPinModalOpen] = useState<boolean>(false);
  const { page_group, projects } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    if (userInfo) {
      const firstname = userInfo.firstName || "";
      const lastname = userInfo.lastName || "";
      if (!firstname && !lastname) {
        setName("");
        return;
      }
      const name = firstname + " " + lastname;
      setName(name);
      setImage(
        userInfo?.profileImage?.urls?.original?.url ?? "/images/users/user.png"
      );
    } else {
      setName("");
    }
  }, [userInfo]);

  const handlePinVerification = (status: boolean) => {
    setVerifyPinModalOpen(false);
    if (status) {
      setEditPrivacyModalOpen(true);
    }
  };

  const handlePrivacyClick = () => {
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    let payload = {};
    if (email) {
      Object.assign(payload, { email });
    }
    if (phone) {
      Object.assign(payload, { email: phone });
    }
    dispatch(REQUEST_VERIFICATION_CODE(payload));
    setVerifyPinModalOpen(true);
  };

  useEffect(() => {
    if (projects?.serviceIds) {
      let org = localStorage.getItem("selectedOrg") || "cudb-live";
      setOrg(org);
    }
  }, [projects?.serviceIds])

  const menu = (
    <ul className="user-dropdown settings-menu">
      {userInfo && userInfo.email && (
        <React.Fragment>
          <li onClick={() => setEditModalOpen(true)}>
            <div className="w-35 pl-0">
              <ReactSVG className="settings-icon" src="/images/male-icon.svg" />
            </div>
            <span>Edit Bio</span>
          </li>
          <li onClick={handlePrivacyClick}>
            <div className="w-35 pl-0">
              <ReactSVG
                src="/images/privacy-icon.svg"
                className="popup-icon settings-icon"
              />
            </div>
            <span>Privacy</span>
          </li>
          <li onClick={() => setEditNotificationModalOpen(true)}>
            <div className="w-35 pl-0">
              <ReactSVG
                src="/images/message-white-icon.svg"
                className="popup-icon settings-icon"
              />
            </div>
            <span>Notification</span>
          </li>
          <li onClick={() => setEditPaymentModalOpen(true)}>
            <div className="w-35 pl-0">
              <ReactSVG
                src="/images/payment-icon.svg"
                className="popup-icon payment settings-icon"
              />
            </div>
            <span>Payment</span>
          </li>
          <li onClick={() => setEditPermissionsModalOpen(true)}>
            <div className="w-35 pl-0">
              <ReactSVG
                src="/images/permission-icon.svg"
                className="popup-icon settings-icon"
              />
            </div>
            <span>Permission</span>
          </li>
        </React.Fragment>
      )}
      {(!userInfo || !userInfo.email) && !dashboard && (
        <li
          onClick={() => {
            history.push("auth/register");
          }}
        >
          <ReactSVG src="/images/male-icon.svg" />
          <span className="ml-3">Register</span>
        </li>
      )}
      {dashboard && (
        <li
          onClick={() => {
            history.push("dashboard");
          }}
        >
          <ReactSVG
            src="/images/message-white-icon.svg"
            className="popup-icon"
            style={{ marginLeft: "-12px" }}
          />
          <span className="ml-3">Dashboard</span>
        </li>
      )}
      <li className="is-logout" onClick={() => setConfirmationDialog(true)}>
        <div className="w-35 pl-0">
          <ReactSVG className="settings-icon" src="/images/logout-icon.svg" />
        </div>
        <span>Logout</span>
      </li>
    </ul>
  );

  const onsetOrg = (org)=>{
    setOrg(org);
    localStorage.setItem("selectedOrg",org);
    window.location.reload();

  };
  const organizationMenu = (
    <ul className="user-dropdown org-dropdown-list">
      <li className="org-dropdown-heading">Switch organization</li>
      {projects?.serviceIds &&
        projects?.serviceIds.map((serviceId) => {
          const org = Array.isArray(serviceId) ? serviceId[0] : serviceId;
          return (
            <li
              onClick={() => onsetOrg(org)}
              key={org}
              className={selectedOrg === org ? "org-option selected" : "org-option"}
            >
              <Checkbox
                checked={selectedOrg === org}
                className="circular-checkbox custom-checkbox"
                value={org}
              />
              <span className="org-option-name">{org}</span>
              {selectedOrg === org && <span className="org-option-tag">Current</span>}
            </li>
          );
        })}
    </ul>
  );

  return (
    <div className="header-panel mr-4">
      <ReactSVG src="/images/logo-icon.svg" className="logo-icon" />
      <div className="d-flex">
        {/* <Clock /> */}
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
          <div className="user-avatar d-flex">
            <img src={image || "/images/users/user.png"} style={{ borderRadius: '50%' }} />
            <p className="mr-1 ml-1">{name}</p>
            <DownOutlined style={{ fontSize: 14 }} />
          </div>
        </Dropdown>
        <Dropdown
          overlay={organizationMenu}
          overlayClassName="org-dropdown"
          placement="bottomRight"
          trigger={["click"]}
        >
          <div className="org-switcher" title={`Organization: ${selectedOrg || "cudb-live"}`}>
            <span className="org-switcher-label">Org</span>
            <span className="org-switcher-value">{selectedOrg || "cudb-live"}</span>
            <DownOutlined style={{ fontSize: 12 }} />
          </div>
        </Dropdown>
      </div>
      {editModalOpen && (
        <EditBioModal onClose={() => setEditModalOpen(false)} />
      )}
      {editPrivacyModalOpen && (
        <EditPrivacyModal onClose={() => setEditPrivacyModalOpen(false)} />
      )}
      {editPaymentModalOpen && (
        <EditPaymentModal
          socket={socket}
          onClose={() => setEditPaymentModalOpen(false)}
        />
      )}
      {editPermissionsModalOpen && (
        <EditPermissionsModal
          onClose={() => setEditPermissionsModalOpen(false)}
        />
      )}
      {editNotificationModalOpen && (
        <EditNotificationModal
          onClose={() => setEditNotificationModalOpen(false)}
        />
      )}
      {verifyPinModalOpen && (
        <VerifyPinModal
          onClose={() => setVerifyPinModalOpen(false)}
          onVerification={handlePinVerification}
        />
      )}
      {confirmationDialog && (
        <ConfirmationModal
          handleConfirm={() => dispatch(LOGOUT())}
          message={"Do you really want to logout?"}
          onClose={() => setConfirmationDialog(false)}
        />
      )}
    </div>
  );
};

export default HeaderPanel;
